<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">岗位支援接收-详情</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">

				<div style="height: 60px;"></div>
				<el-row style="margin-left: 100px;">
					<el-col :span="4">
						<span>
							支援项目：
						</span>
						{{$parent.ruleForm.project_name}}
					</el-col>
					<el-col :span="6">
						<span>
							开始时间：
						</span>
						{{$parent.ruleForm.start_date}}
					</el-col>
					<el-col :span="4">
						<span>
							结束时间：
						</span>
						{{$parent.ruleForm.end_date}}
					</el-col>
				</el-row>

				<div class="shang">
					<h4 style="padding-left: 5px;">支援人</h4>
				</div>

				<el-row style="margin: 0 100px;">
					<el-table :data="$parent.support_staff_List" style="width: 100%">
						<!-- <el-table-column type="selection" width="55">
						</el-table-column> -->
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column prop="staff_name" label="姓名" align="center"></el-table-column>
						<el-table-column prop="staff_card" label="身份证号" width="300px" align="center"></el-table-column>
						<el-table-column prop="staff_telephone" label="手机号" align="center"></el-table-column>
						<el-table-column prop="daily_wage" label="日工资" align="center"></el-table-column>
						<el-table-column prop="support_duration" label="时长" align="center"></el-table-column>
						<el-table-column label="操作" align="center" width="300">
							<template slot-scope="scope">
								<span>{{scope.row.state}}</span>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" width="300">
							<template slot-scope="scope">
								<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;"
									@click="xiugai(scope.row)" v-if="scope.row.state === '1'">修改
								</el-button>
								<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;"
									@click="operation(scope.row.staff_id, '0')" v-if="scope.row.state === '0'">
									接收
								</el-button>
								<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;"
									@click="operation(scope.row.staff_id, '1')" v-if="scope.row.state === '0'">
									退回
								</el-button>
								<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;"
									@click="end(scope.row)" v-if="scope.row.state === '1' ">完成
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-row>

				<el-row style="margin: 0 100px; margin-top: 40px; text-align: center;">
					<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B; width: 120px;"
						@click="operation(null, '2')" v-if="$parent.ruleForm.support_type === '0'">接收
					</el-button>
					<el-button type="primary"
						style="background-color: #FFFFFF; border-color: #006E4B; color: #006E4B; width: 120px;"
						@click="operation(null, '3')" v-if="$parent.ruleForm.support_type === '0'">退回
					</el-button>
					<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B; width: 120px;"
						@click="End()" v-if="$parent.ruleForm.support_type != '0'">完成
					</el-button>
				</el-row>


			</div>
		</div>

		<el-dialog title="退回原因" :visible.sync="dialogVisible" width="35%" :close-on-click-modal="false">
			<el-input type="textarea" v-model="return_reason" :rows="7"></el-input>
			<div style="width: 100%; height: 30px; padding-top: 10px;">
				<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B; float: right;"
					@click="operation(null, '3')">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="修改" :visible.sync="dialogVisibles" width="30%" :close-on-click-modal="false">
			<span style="font-size: 16px;margin-left: 8%;">日工资：</span>
			<el-input v-model="form.daily_wage" placeholder="请输入日工资" style="width: 70%;"></el-input>
			<div style="width: 100%; height: 30px; padding-top: 10px;">
				<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;margin-left: 42%;"
					@click="save()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="岗位支援结束" :visible.sync="dialogVisiblejs" width="30%" :close-on-click-modal="false">
			<div>
				<span style="font-size: 16px;margin-left: 8%;">奖励：</span>
				<el-input type="number" v-model="form.reward" placeholder="请输入奖励" style="width: 75%;"></el-input>
			</div>
			<div style="margin-top: 20px;">
				<span style="font-size: 16px;margin-left: 8%;">惩罚：</span>
				<el-input type="number" v-model="form.punishment" placeholder="请输入惩罚" style="width: 75%;"></el-input>
			</div>
			<div style="width: 100%; height: 30px; padding-top: 10px;">
				<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;margin-left: 48%;"
					@click="endjs()">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="岗位支援结束" :visible.sync="dialogVisiblejsall" width="30%" :close-on-click-modal="false">
			<div>
				<span style="font-size: 16px;margin-left: 8%;">奖励：</span>
				<el-input type="number" v-model="form.reward" placeholder="请输入奖励" style="width: 75%;"></el-input>
			</div>
			<div style="margin-top: 20px;">
				<span style="font-size: 16px;margin-left: 8%;">惩罚：</span>
				<el-input type="number" v-model="form.punishment" placeholder="请输入惩罚" style="width: 75%;"></el-input>
			</div>
			<div style="width: 100%; height: 30px; padding-top: 10px;">
				<el-button type="primary" style="background-color: #006E4B; border-color: #006E4B;margin-left: 48%;"
					@click="Endjs()">确 定</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import axios from "axios";
	export default {
		data() {
			return {
				a: [],
				return_reason: "",
				dialogVisible: false,
				dialogVisibles: false,
				dialogVisiblejs: false,
				dialogVisiblejsall: false,
				form: {
					daily_wage: '',
					support_duration: '',
					id: '',
					support_id: '',
					reward: '',
					punishment: '',
					supportStaff_id: '',
				}
			}
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			Return() {
				this.$parent.Return();
			},
			operationFrom() {
				this.return_reason = "";
				this.dialogVisible = true;
			},
			xiugai(e) {
				this.dialogVisibles = true;
				this.form.id = e.id;
				this.form.daily_wage = e.daily_wage;
				this.form.support_duration = e.support_duration;
			},
			async save() {
				const url = this.$globals.http + "/SupportStaff/updateByPrimaryKeySelective";
				axios.post(url, {
					id: this.form.id,
					daily_wage: this.form.daily_wage,
					support_duration: this.form.support_duration
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;

					if (code === '200') {
						this.$message.success(data);
						this.dialogVisibles = false;

					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			end(e) {
				this.form.reward = '';
				this.form.punishment = '';
				this.form.supportStaff_id = e.id;
				this.form.support_id = e.support_id;
				this.dialogVisiblejs = true;
			},
			async endjs() {
				const url = this.$globals.http + "/SupportPayroll/postSupportWages";
				axios.post(url, {
					support_id: this.form.support_id,
					supportStaff_id: this.form.supportStaff_id,
					reward: this.form.reward,
					punishment: this.form.punishment,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.$message.success(data);
						this.dialogVisiblejs = false;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			End(){
				this.form.reward = '';
				this.form.punishment = '';
				this.form.support_id = this.$parent.ruleForm.id;
				this.dialogVisiblejsall = true;
			},
			async Endjs() {
				const url = this.$globals.http + "/SupportPayroll/postSupportWagesEnd";
				axios.post(url, {
					support_id: this.form.support_id,
					reward: this.form.reward,
					punishment: this.form.punishment,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.$message.success(data);
						this.dialogVisiblejsall = false;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			async operation(e, falg) {
				var url = "postSupport/operation";

				switch (falg) {
					case '0':
					var record = {
						id: this.$parent.ruleForm.id,
						support_staff: e,
						is_show: '1'
					};
					break;
					case '1':
						var record = {
							id: this.$parent.ruleForm.id,
							support_staff: e,
							is_show: '2'
						};
						break;
					case '2':
						var record = {
							id: this.$parent.ruleForm.id,
							is_show: "1"
						};
						break;
					case '3':
						var record = {
							id: this.$parent.ruleForm.id,
							is_show: "2"
						};
						break;
				}
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);

						if (falg === '3') {
							this.dialogVisible = false;
						}

						this.Return();
					} else {
						this.$message.warning(data);
					}
				}
			}
		}
	}
</script>

<style>
	.shang h4 {
		margin-top: 60px;
		margin-left: 100px;
		border-left: 3px solid #00724e;
		font-weight: 900;
	}

	.el-dialog__title {
		margin-left: 45% !important;
	}
</style>



// WEBPACK FOOTER //
// Gwzyjs_edit.vue?395b842e